import React from 'react';
import { Link } from 'react-router-dom';
import { Zap } from 'lucide-react';
import Button from '../UI/Button';
import SearchBar from '../UI/SearchBar';
import './Navbar.css';

const Navbar = () => {
    return (
        <nav className="navbar glass-panel">
            <div className="container navbar-content">
                <Link to="/" className="logo">
                    <Zap className="logo-icon" />
                    <span className="text-gradient">OnlineToolSphere</span>
                </Link>

                <SearchBar />

                <div className="nav-links">
                    <Link to="/tools" className="nav-link">All Tools</Link>

                </div>
            </div>
        </nav>
    );
};

export default Navbar;
